const Box = ({ label, className = "" }) => (
  <div className={`border border-neutral-600 px-1.5 pt-0.5 ${className}`}>
    <div className="text-[7.5px] uppercase tracking-wider text-neutral-700 font-bold leading-tight">{label}</div>
  </div>
);

const VehicleBlock = ({ n }) => (
  <div className="flex-1 min-h-0 flex flex-col border-2 border-neutral-900" data-testid={`operator-sheet-vehicle-${n}`}>
    <div className="grid grid-cols-[1.5fr_1.3fr_1fr] h-[15mm]">
      <Box label={`${n} · Veicolo (marca e modello)`} className="border-0 border-r" />
      <Box label="Targa" className="border-0 border-r" />
      <Box label="Ore lavorate" className="border-0 bg-neutral-100" />
    </div>
    <div className="flex-1 flex flex-col border-t border-neutral-600 px-1.5">
      <div className="text-[7.5px] uppercase tracking-wider text-neutral-700 font-bold leading-tight pt-0.5">Lavori eseguiti</div>
      {[0, 1].map((i) => <div key={i} className="flex-1 border-b border-neutral-300 last:border-b-0" />)}
    </div>
    <div className="grid grid-cols-5 h-[9mm] border-t border-neutral-600" data-testid={`operator-sheet-materials-${n}`}>
      {["Base", "Trasparente", "Pastello", "Fondo", "Varie"].map((m, i) => <Box key={m} label={m} className={`border-0 ${i < 4 ? "border-r" : ""}`} />)}
    </div>
  </div>
);

export const OperatorSheet = ({ side }) => (
  <div className="w-1/2 h-full px-[6mm] py-[5mm] flex flex-col gap-[2mm] overflow-hidden" data-testid={`operator-sheet-${side}`}>
    <div className="flex items-center justify-between gap-2 border-b-2 border-neutral-900 pb-0.5">
      <img src="/logo.png" alt="Centro Auto Pontedera" className="h-5 w-auto" />
      <div className="text-[12px] font-extrabold uppercase leading-none">Scheda lavoro operatore</div>
    </div>
    <div className="grid grid-cols-[2fr_1fr] gap-1 h-[10mm]">
      <Box label="Nome operatore" />
      <Box label="Data" />
    </div>
    {[1, 2, 3, 4].map((n) => <VehicleBlock key={n} n={n} />)}
    <div className="grid grid-cols-[1fr_2fr] gap-1 h-[10mm]">
      <Box label="Totale ore giornata" className="bg-neutral-100" />
      <Box label="Firma operatore" />
    </div>
  </div>
);
